import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tous-ticket-caisse',
  templateUrl: './tous-ticket-caisse.component.html',
  styleUrls: ['./tous-ticket-caisse.component.scss']
})
export class TousTicketCaisseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
